'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { useCustomRouter } from '@/hooks/useCustomRouter';

const DETAIL_REVIEW_ID = 'detailReviewId';

export const ReviewDetailController = () => {
  const router = useCustomRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const parsedReviewId = Number(searchParams.get(DETAIL_REVIEW_ID));
  const reviewId =
    Number.isInteger(parsedReviewId) && parsedReviewId > 0
      ? parsedReviewId
      : undefined;

  const handleClose = () => {
    const nextSearchParams = new URLSearchParams(searchParams.toString());
    nextSearchParams.delete(DETAIL_REVIEW_ID);

    const search = nextSearchParams.toString();

    router.replace(`${pathname}${search ? `?${search}` : ''}`, {
      scroll: false,
    });
  };

  return (
    <ReviewDetailSessionPortal
      open={Boolean(reviewId)}
      onClose={handleClose}
      reviewId={reviewId}
    />
  );
};
